import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import product from '@/pages/product'
import about from '@/pages/about'
import login from '@/pages/login'
import mangement from '@/pages/mangement'
import forgetpassword from '@/pages/forgetpassword'
import news from '@/pages/news'
import join from '@/pages/join'
import JRS from '@/pages/JRS'

import cooperation from '@/pages/cooperation'
import contact from '@/pages/contact'
import producthhmnq from '@/pages/producthhmnq'
import intern from '@/components/contentcoms/joincontentcoms/intern'
import joincontent from "@/components/contentcoms/joincontentcoms/joincontent"
import programmer from '@/components/contentcoms/joincontentcoms/programmer'
import modeler from '@/components/contentcoms/joincontentcoms/modeler'
import engineer from '@/components/contentcoms/joincontentcoms/engineer'
import productvr from '@/pages/productvr'
import productcp from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productcp'
import productqrw from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productqrw'
import productzncy from '@/pages/productzncy'
import zncajkzzx from '@/components/contentcoms/prodecutcontentcoms/zncyxlcp/zncajkzzx'
import zncq from '@/components/contentcoms/prodecutcontentcoms/zncyxlcp/zncq'
import znzzjsjxt from '@/components/contentcoms/prodecutcontentcoms/zncyxlcp/znzzjsjxt'
import producthhxnsx from '@/pages/producthhxnsx'
import hhxnkc from '@/components/contentcoms/prodecutcontentcoms/hhxnsxxlcp/hhxnkc'
import xnzhyl from '@/components/contentcoms/prodecutcontentcoms/hhxnsxxlcp/xnzhyl'
import hharxlxt from '@/components/contentcoms/prodecutcontentcoms/hhxnsxxlcp/hharxlxt'
import hhxnxl from '@/components/contentcoms/prodecutcontentcoms/hhxnsxxlcp/hhxnxl'
import productznhy from '@/pages/productznhy'
import zncbajyckzz from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/zncbajyckzz'
import zxlykwrtjcspt from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/zxlykwrtjcspt'
import znzzjsjxtload from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/znzzjsjxtload'
import cbqxdhxt from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/cbqxdhxt'
import zhhsjzqxt from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/zhhsjzqxt'
import fzsycbznbp from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/fzsycbznbp'
import cbarycywxt from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/cbarycywxt'
import swszdqcp from '@/components/contentcoms/prodecutcontentcoms/znhyxlcp/swszdqcp'
import producthhwhyx from '@/pages/producthhwhyx'
import hhwhyxgkj from '@/components/contentcoms/prodecutcontentcoms/hhwhyxlcp/hhwhyxgkj'
import lssykp from '@/components/contentcoms/prodecutcontentcoms/hhwhyxlcp/lssykp'
import cjtytj from '@/components/contentcoms/prodecutcontentcoms/hhwhyxlcp/cjtytj'
import ipfn from '@/components/contentcoms/prodecutcontentcoms/hhwhyxlcp/ipfn'









import productytmnq from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productytmnq'
import productldmnq from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productldmnq'
import productgmdss from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productgmdss'
import productecdis from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productecdis'

import producthgzymnq from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthgzymnq'
import productmnq from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productmnq'
import producthwjzyxg from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthwjzyxg'
import producthhyqmnq from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthhyqmnq'
import producthhjyykhpg from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthhjyykhpg'
import productpbcbczmnq from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productpbcbczmnq'
import productvzhylfzxt from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productvzhylfzxt'
import producthsyjylfz from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthsyjylfz'
import producthsltsjyl from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthsltsjyl'
import producthsxtylfz from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/producthsxtylfz'
import productsjgkycbsw from '@/components/contentcoms/prodecutcontentcoms/hhmnqxlcp/productsjgkycbsw'





import producthsyl from '@/pages/producthsyl'
import hjzzylxt from '@/components/contentcoms/prodecutcontentcoms/hsylxlcp/hjzzylxt'
import hsltsjylxt from '@/components/contentcoms/prodecutcontentcoms/hsylxlcp/hsltsjylxt'
import hsyjylxt from '@/components/contentcoms/prodecutcontentcoms/hsylxlcp/hsyjylxt'
import VTSzhylxt from '@/components/contentcoms/prodecutcontentcoms/hsylxlcp/VTSzhylxt'

import producthlwhhjy from '@/pages/producthlwhhjy'
import hlwhhjy from '@/components/contentcoms/prodecutcontentcoms/hlwxlcp/hlwhhjy'
import newscontent from '@/components/contentcoms/newscontentcoms/newscontent'

import Oldnewscontent from '@/components/contentcoms/newscontentcoms/Oldnewscontent'

import webproductlist from '@/pages/webproductlist'

import lmmad from '@/pages/lmmad'
import jdcj from '@/pages/jdcj'
import hccj from '@/pages/hccj'
import rdcj from '@/pages/rdcj'

import pdf from '@/pages/pdf'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: pdf
    },
    {
      path: '/JRS',
      name: 'JRS',
      component: JRS
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/webproductlist',
      name: 'webproductlist',
      component: webproductlist
    },

    {
      path: '/lmmad',
      name: 'lmmad',
      component: lmmad
    },
    {
      path: '/jdcj',
      name: 'jdcj',
      component: jdcj
    },
    {
      path: '/hccj',
      name: 'hccj',
      component: hccj
    },
    {
      path: '/rdcj',
      name: 'rdcj',
      component: rdcj
    },

    {
      path: '/about',
      name: 'about',
      component: about
    },    
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/newscontent',
      name: 'newscontent',
      component: newscontent,
      meta: {
        keepAlive: false
      }
    },
    
    {
      path: '/Oldnewscontent',
      name: 'Oldnewscontent',
      component: Oldnewscontent,
      meta: {
        keepAlive: false
      }
    },

    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/mangement',
      name: 'mangement',
      component: mangement 
    },
    {
      path: '/forgetpassword',
      name: 'ForgetPassword',
      component: forgetpassword
    },
    
    {
      path: '/join',
      name: 'join',
      component: join,
      children: [{
          path: 'index',
          component: joincontent
        },
        {
          path: 'intern',
          component: intern
        },
        {
          path: 'programmer',
          component: programmer
        },
        {
          path: 'modeler',
          component: modeler
        },
        {
          path: 'engineer',
          component: engineer
        }
      ]
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/producthhmnq',
      name: 'producthhmnq',
      // eslint-disable-next-line no-undef
      component: producthhmnq,
      children: [{
          path: 'productcp',
          component: productcp
        },
        {
          path: 'productqrw',
          component: productqrw
        },
        {
          path: 'productytmnq',
          component: productytmnq
        },
        {
          path: 'productldmnq',
          component: productldmnq
        },
        {
          path: 'productgmdss',
          component: productgmdss
        },
        {
          path: 'productecdis',
          component: productecdis
        },
        {
          path: 'producthgzymnq',
          component: producthgzymnq
        },
        {
          path: 'productmnq',
          component: productmnq
        },
        {
          path: 'producthwjzyxg',
          component: producthwjzyxg
        },
        {
          path: 'producthhyqmnq',
          component: producthhyqmnq
        },
        {
          path: 'producthhjyykhpg',
          component: producthhjyykhpg
        },
        {
          path: 'productpbcbczmnq',
          component: productpbcbczmnq
        },
        {
          path: 'productvzhylfzxt',
          component: productvzhylfzxt
        },
        {
          path: 'producthsyjylfz',
          component: producthsyjylfz
        },
        {
          path: 'producthsltsjyl',
          component: producthsltsjyl
        },
        {
          path: 'producthsxtylfz',
          component: producthsxtylfz
        },
        {
          path: 'productsjgkycbsw',
          component: productsjgkycbsw
        },
      ]
    },
    {
      path: '/productvr',
      name: 'productvr',
      // eslint-disable-next-line no-undef
      component: productvr
    },
    {
      path: '/productzncy',
      name: 'productzncy',
      // eslint-disable-next-line no-undef
      component: productzncy,
      children: [{
          path: 'zncajkzzx',
          component: zncajkzzx
        },
        {
          path: 'zncq',
          component: zncq
        },
        {
          path: 'znzzjsjxt',
          component: znzzjsjxt
        },

      ]
    },
    {
      path: '/producthsyl',
      name: 'producthsyl',
      component: producthsyl,
      children: [{
          path: 'hjzzylxt',
          component: hjzzylxt
        },
        {
          path: 'hsltsjylxt',
          component: hsltsjylxt
        },
        {
          path: 'hsyjylxt',
          component: hsyjylxt
        },
        {
          path: 'VTSzhylxt',
          component: VTSzhylxt
        }
      ]
    },
    {
      path: '/producthlwhhjy',
      name: 'producthlwhhjy',
      // eslint-disable-next-line no-undef
      component: producthlwhhjy
    },
    {
      path: '/producthhxnsx',
      name: 'producthhxnsx',
      // eslint-disable-next-line no-undef
      component: producthhxnsx,
      children: [{
          path: 'hhxnxl',
          component: hhxnxl
        },
        {
          path: 'hhxnkc',
          component: hhxnkc
        },
        {
          path: 'xnzhyl',
          component: xnzhyl
        },
        {
          path: 'hharxlxt',
          component: hharxlxt
        },
      ]
    },
    {
      path: '/productznhy',
      name: 'productznhy',
      // eslint-disable-next-line no-undef
      component: productznhy,
      children: [{
          path: 'zncbajyckzz',
          component: zncbajyckzz
        },
        {
          path: 'zxlykwrtjcspt',
          component: zxlykwrtjcspt
        },
        {
          path: 'znzzjsjxtload',
          component: znzzjsjxtload
        },
        {
          path: 'cbqxdhxt',
          component: cbqxdhxt
        },
        {
          path: 'zhhsjzqxt',
          component: zhhsjzqxt
        },
        {
          path: 'fzsycbznbp',
          component: fzsycbznbp
        },
        {
          path: 'cbarycywxt',
          component: cbarycywxt
        },
        {
          path: 'swszdqcp',
          component: swszdqcp
        },
      ]
    },
    {
      path: '/producthhwhyx',
      name: 'producthhwhyx',
      // eslint-disable-next-line no-undef
      component: producthhwhyx,
      children: [{
          path: 'hhwhyxgkj',
          component: hhwhyxgkj
        },
        {
          path: 'lssykp',
          component: lssykp
        },
        {
          path: 'cjtytj',
          component: cjtytj
        },
        {
          path: 'ipfn',
          component: ipfn
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js